import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MinuteConditionDTO } from './interfaces/minute-condition.interface';
import { environment } from 'src/environments/enviroments';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';

@Injectable({
  providedIn: 'root'
})
export class MinuteConditionsService {

  private rootEndpoint: string = `${environment.apiUrl}/MinuteConditions`;
  constructor(private hthpClient: HttpClient) { }

  getAllMinuteConditions(): Observable<MinuteConditionDTO[]> {
    return this.hthpClient.get<MinuteConditionDTO[]>(this.rootEndpoint);
  }

  postMinuteCondition(name: string): Observable<ActionResponseDTO<MinuteConditionDTO | null>> {
    const body = {
      name: name
    };
    return this.hthpClient.post<ActionResponseDTO<MinuteConditionDTO | null>>(this.rootEndpoint, body);
  }
}
